import { z } from 'zod'

export enum AssetType {
  Nft = 'NFT',
  Cryptocurrency = 'Cryptocurrency',
}

export const assetTypeSchema = z.nativeEnum(AssetType)
